import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import type {YN} from '../../common/shared/api/YN.type';

/**
 * TV포인트 약관 동의 설정
 *
 * Origin: pageNicolasApi.setTvPointTermsCheck
 * API: POST /api/v1/store/terms/set/page_private_tvpoint_offer
 */
export async function postStoreTermsSetTvPoint(
  {
    agree,
  }: {
    agree: YN;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v1/store/terms/set/page_private_tvpoint_offer',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: {
        agree,
      },
    },
    options
  );

  return response.data;
}
